import clsx from 'clsx';
import { IconContext } from 'react-icons';
import { panelIds } from './types';
import type { MobileNavigationProps } from './types';
import './MobileNavigation.scss';
import Header from './Header';
import MenuDialog from './MenuDialog';
import Search from './Search';
import useMobilePanel from './useMobilePanel';

const iconContext = { size: '20' };

export default function MobileNavigation({
  logo,
  menu,
  search,
  account,
  cart,
}: MobileNavigationProps) {
  const { panel, headerRef, togglePanel, close, onKeyDown, onMenuClosed } =
    useMobilePanel();
  const menuOpen = panel === 'menu';

  const headerProps = {
    logo,
    cart,
    menu,
    search,
    panel,
    onToggle: togglePanel,
  };

  return (
    <IconContext.Provider value={iconContext}>
      <div
        className={clsx('bio-mobile-navigation', {
          'bio-mobile-navigation--menu-open': menuOpen,
        })}
        data-mobile-navigation=""
        onKeyDown={onKeyDown}
      >
        <Header {...headerProps} headerRef={headerRef} />
        {search && (
          <Search
            {...search}
            id={panelIds.search}
            open={panel === 'search'}
            onDismiss={close}
          />
        )}
        {menu && (
          <MenuDialog
            {...menu}
            open={menuOpen}
            header={<Header {...headerProps} />}
            account={account}
            onClose={close}
            onClosed={onMenuClosed}
          />
        )}
      </div>
    </IconContext.Provider>
  );
}
